<div id="cont-div" class="container container-ficha" *ngIf="t3">
    <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
            <h2 class="title-ficha">{{t3.longtitle}}</h2>
            <div class="summary-ficha">{{t3.summary}}</div>
            <div class="info-ficha">
                <div class="col-md-8">
    <!--                 <small *ngIf="t3.author" class="author">{{ t3.author }}</small>
                    <hr class="separator" *ngIf="t3.author"> -->
                    <div class="date-container">
                        <small *ngIf="t3.publication">Publicación: {{ t3.publication | date:'MMMM yyyy' }}</small>
                        <small *ngIf="t3.lastUpdated">Actualización: {{ t3.lastUpdated | date:'MMMM yyyy' }}</small>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="t3.img">
                <div class="div-section">
                    <ng-container *ngIf="isUploadDir">
                        <img class="img-fluid img-ficha" src="{{URL}}{{t3.img}}" alt="{{t3.shorttitle}}">
                    </ng-container>
                    <ng-container *ngIf="!isUploadDir">
                        <img class="img-fluid img-ficha" src="{{t3.img}}" alt="{{t3.shorttitle}}">
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div class="col-sm-1">
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
            <div #divref id="id-section" class="div-section" *ngFor="let p of sections">
                <ng-container *ngIf="p.title">
                    <div class="title-section">{{p.title}}</div>
                </ng-container>
                <ng-container *ngFor="let o of subsections">
                    <ng-container *ngIf="p.id == o.idsection">
                        <div class="div-subsection">
                            <ng-container *ngIf="o.title">
                                <div class="title-subsection">{{o.title}}</div>
                            </ng-container>
                            <ng-container *ngIf="p.id == o.idsection">
                                <!-- <p>{{o.content}}</p> -->
                                <div style="margin-bottom: 1rem;" [innerHTML]="o.content"></div>
                            </ng-container>

                            <ng-container *ngFor="let p of img">
                                <ng-container *ngIf="+p.order==+o.order && p.urldata">
                                    <div class="text-center">
                                        <ng-container *ngIf="p.urldata.substring(1,7)==='upload'">
                                            <img class="img-fluid" src="{{URL}}{{p.urldata}}" alt="Imagen de ficha">
                                        </ng-container>
                                        <ng-container *ngIf="p.urldata.substring(1,7)!=='upload'">
                                            <img class="img-fluid" src="{{p.urldata}}" alt="Imagen de ficha">
                                        </ng-container>
                                    </div>
                                    <small *ngIf="p.numeration && p.title">
                                        <i [innerHTML]="p.numeration"></i>
                                        <span [innerHTML]="p.title"></span>
                                    </small>
                                    <br>
                                    <small *ngIf="p.note" [innerHTML]="p.note"></small>
                                    <br>
                                    <br>                                    
                                </ng-container>
                            </ng-container>
                            <ng-container *ngFor="let p of img_ref">
                                <ng-container *ngIf="+p.order==+o.order">
                                    <br>
                                    <div class="text-center" style="width: 100%;">
                                        <ng-container *ngIf="p.urldata.substring(1,7)==='upload'">
                                            <img class="img-fluid img-ficha" src="{{URL}}{{p.urldata}}"
                                                alt="Imagen de ficha">
                                        </ng-container>
                                        <ng-container *ngIf="p.urldata.substring(1,7)!=='upload'">
                                            <img class="img-fluid img-ficha" src="{{p.urldata}}" alt="Imagen de ficha">
                                        </ng-container>

                                    </div>
                                    <br>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngFor="let p of datawrapper">
                                <ng-container *ngIf="+p.order==+o.order && p.urldata">

                                    <div class="datawrapper-container">
                                        <ng-container *ngIf="p.externalframe + '' != 'null'">
                                            <ng-container *ngIf="p.isresponsive; else noGraphContent">
                                                <div class="row">
                                                    <ng-container
                                                        *ngFor="let iframe of p.externalframe.split('<iframe'); let i = index; let last = last; let total = count">
                                                        <div *ngIf="iframe.trim() !== ''"
                                                            [ngClass]="{'col-md-6': ((total-1) % 2 === 0) || (!last), 'col-md-12': ((total-1) % 2 !== 0) && last}">
                                                            <div [innerHTML]="'<iframe' + iframe | sanitizer"></div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                            <ng-template #noGraphContent>
                                                <div [innerHTML]="p.externalframe | sanitizer"></div>
                                            </ng-template>
                                        </ng-container>
                                    </div>
                                    <small *ngIf="p.numeration && p.title">
                                        <i [innerHTML]="p.numeration"></i>
                                        <span [innerHTML]="p.title"></span>
                                    </small>
                                    <br>
                                    <small *ngIf="p.note" [innerHTML]="p.note"></small>
                                    <br>
                                    <br>   
                                </ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </div>

            <!-- Incia Tema relacionado -->
            <ng-container *ngIf="tematic">
                <hr>
                <div class="d-flex align-items-center">
                    <h6 class="bib-title mb-0" style="margin-right: 8px;">Tema </h6>
                    <small
                        [ngStyle]="{'padding': '5px', 'background-color': tematic.color, 'color': 'white','border-radius': '3px'}">
                        {{ tematic.title }}
                    </small>
                </div>
            </ng-container>
            <!-- Fin Tema relacionado -->

            <!-- Incia keywords relacionado -->
            <ng-container *ngIf="t3 && t3.tags">
                <hr>
                <div class="d-flex align-items-center flex-wrap">
                    <h6 class="bib-title mb-0" style="white-space: nowrap;">Palabras clave </h6>
                    <div class="d-flex align-items-center flex-wrap gap-1 ms-2">
                        <ng-container *ngFor="let tag of t3.tags.split(','); let last = last">
                            <span (click)="buscarPorKeyword(tag.trim())" class="underline" style="margin-right: 4px; cursor: pointer">
                                {{ tag.trim() }}
                            </span>
                            <span *ngIf="!last" style="margin-right: 4px;">|</span>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <!-- Fin keywords relacionado -->

            <!-- Incia Contenido relacionado -->
            <ng-container *ngIf="tier3Related && tier3Related.length > 0">
                <hr>
                <h6 class="bib-title">Contenido relacionado </h6>
                <br>
                <div class="row ms-3">
                    <ng-container *ngFor="let t3r of tier3Related">
                        <ng-container *ngIf="t3r.longtitle && t3r.img">
                            <div class="card me-2 mb-2 px-0" style="width: 18rem;">
                                <ng-container *ngIf="t3r.img.substring(1,7)==='upload'">
                                    <img class="card-img-top" src="{{URL}}{{t3r.img}}" alt="image">
                                </ng-container>
                                <ng-container *ngIf="t3r.img.substring(1,7)!=='upload'">
                                    <img class="card-img-top" src="{{t3r.img}}" alt="image">
                                </ng-container>
                                <div class="card-body">
                                    <a [routerLink]="'../' + t3r.code" target="_blank"> 
                                        <p class="card-text">{{t3r.longtitle}}</p>
                                    </a>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
            <!-- Fin Contenido relacionado -->

            <!-- Inicio sección noticias relacionadas -->

            <ng-container *ngIf="newsFlag==1">
                <hr>
                <h6 class="bib-title">Noticias relacionadas</h6>
                <br>
                <div class="row ms-3">
                    <ng-container *ngFor="let new of news">
                        <div class="card me-2 mb-2 px-0" style="width: 18rem;">
                            <ng-container *ngIf="new.img.substring(1,7)==='upload'; else regularImage">
                                <img class="card-img-top" [src]="URL + new.img" alt="image">
                            </ng-container>
                            <ng-template #regularImage>
                                <img class="card-img-top" [src]="new.img" alt="image">
                            </ng-template>
                            <div class="card-body">
                                <a routerLink="/actualidad/{{new.id}}">
                                    <p class="card-text">{{new.title}}</p>
                                </a>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <!-- Fin sección noticias relacionadas -->


            <hr>
            <ng-container *ngIf="biblio.length>0">
                <div class="div-section">

                    <h6 class="bib-title">Referencias bibliográficas</h6>

                    <ng-container *ngIf="flagBiblio==1">
                        <p class="bib-trend" *ngFor="let p of biblio">
                            <ng-container *ngIf="p.urlsource">
                                <a href="{{p.urlsource}}" target="_blank" class="external-link">{{p.content}}</a>
                            </ng-container>
                            <ng-container *ngIf="!p.urlsource">
                                <span class="no-link">{{p.content}}</span>
                            </ng-container>
                        </p>
                        <div class="text-center">
                            <a (click)="showMore()" style="cursor: pointer;"> <b>{{action}}</b></a>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="flagBiblio==0">
                        <p class="bib-trend" *ngFor="let p of biblio">
                            <ng-container *ngIf="p.urlsource">
                                <a href="{{p.urlsource}}" target="_blank" class="external-link">{{p.content}}</a>
                            </ng-container>
                            <ng-container *ngIf="!p.urlsource">
                                <span class="no-link">{{p.content}}</span>
                            </ng-container>
                        </p>
                    </ng-container>

                </div>
            </ng-container>

            <!-- Inciio commentarios -->
            <hr>
            <ng-container>
                <!-- <h6 class="bib-title">Comentarios</h6> -->
                <app-comment-list [Tier3]="t3"></app-comment-list>
                <!--  <app-comment-list currentUserId="15"></app-comment-list> -->
            </ng-container>
            <!-- Fin commentarios -->

        </div>
        <div class="col-sm-1">
            <ng-container *ngIf="primarySource.length>0">
                <br>
                <div class="primary-source">
                    <h5>Fuentes primarias</h5>
                    <ng-container *ngFor="let o of primarySource">
                        <a class="mb-2" href="{{o.url}}" target="_black">{{o.title}}</a>
                    </ng-container>
                </div>
            </ng-container>
        </div>


    </div>
</div>